import React from 'react';
import { ScorecardCategories } from '../../../../ScorecardPage/ScorecardBody/ScorecardCategories';
import { ProsAndCons } from './ProsAndCons';
import { Footer } from './Footer';
import { User } from '../../../../../../../entities/User';
import { Scorecard } from '../../../../../../../entities/applicant_tracking/Scorecard';

interface PropTypes {
  currentUser: User;
  scorecard: Scorecard;
  viewAllScorecards: boolean;
}

export function ScorecardBody(props: PropTypes) {
  return (
    <div className='scorecard-body'>
      <ScorecardCategories
        scorecard={props.scorecard}
        setScorecard={null}
        fillColorClass='text-rating-color'
        className='mb-3'
      />
      <ProsAndCons scorecard={props.scorecard} />
      <Footer
        currentUser={props.currentUser}
        scorecard={props.scorecard}
        viewAllScorecards={props.viewAllScorecards}
      />
    </div>
  );
}
